// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__Huplc","link":"HeaderSimple_link__4Zzlb"};